/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, Interface } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenInfo",
        outputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "pair",
                type: "address",
            },
            {
                internalType: "address",
                name: "agentToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "string",
                        name: "name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "_name",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "ticker",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "supply",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "marketCap",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "volume",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "volume24H",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "prevPrice",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lastUpdated",
                        type: "uint256",
                    },
                ],
                internalType: "struct Bonding.Data",
                name: "data",
                type: "tuple",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "image",
                type: "string",
            },
            {
                internalType: "string",
                name: "twitter",
                type: "string",
            },
            {
                internalType: "string",
                name: "telegram",
                type: "string",
            },
            {
                internalType: "string",
                name: "youtube",
                type: "string",
            },
            {
                internalType: "string",
                name: "website",
                type: "string",
            },
            {
                internalType: "bool",
                name: "trading",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "tradingOnUniswap",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_ticker",
                type: "string",
            },
            {
                internalType: "uint8[]",
                name: "cores",
                type: "uint8[]",
            },
            {
                internalType: "string",
                name: "desc",
                type: "string",
            },
            {
                internalType: "string",
                name: "img",
                type: "string",
            },
            {
                internalType: "string[4]",
                name: "urls",
                type: "string[4]",
            },
            {
                internalType: "uint256",
                name: "purchaseAmount",
                type: "uint256",
            },
        ],
        name: "launch",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "buy",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "sell",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "assetRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "srcTokenAddress",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
        ],
        name: "unwrapToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "gradThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export class BondingCurve__factory {
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
BondingCurve__factory.abi = _abi;
